export default "__VITE_ASSET__CzqrPADh__"